import { Box, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

const APPOINTMENT_WRAPPER_INSET = 7; // 4px padding + 3px border

export const DraggableAppointmentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isDragging" && prop !== "isDragOver",
})<{
  isDragging?: boolean;
  isDragOver?: boolean;
}>(({ isDragging, isDragOver }) => ({
  margin: `0 -${APPOINTMENT_WRAPPER_INSET}px`,
  border: `3px dashed ${isDragOver ? colors.primary.main : "transparent"}`,
  borderRadius: "16px",
  padding: "3px",
  backgroundColor: isDragOver ? colors.background.lightBlue : "transparent",
  opacity: isDragging ? 0.5 : 1,
  boxShadow: isDragging ? "0 8px 24px rgba(0,0,0,0.15)" : "none",
  transition:
    "border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease",
}));
